import {BrowserRouter as Router,Route,Routes} from "react-router-dom"
import Header from "./components/layout/Header"
import Home from "./components/home/Home"
import Footer from "./components/layout/Footer"
import Contact from "./components/contact/Contact"
import About from "./components/about/About"
import Cart from "./components/cart/Cart"
import Shipping from "./components/cart/Shipping"
import ConfirmOrder from "./components/cart/ConfirmOrder"
import PaymentSucess from "./components/cart/PaymentSucess"
import Login from "./components/login/Login"
import MyOrders from "./components/myOrders/MyOrders"
import OrderDetails from "./components/myOrders/OrderDetails"
import Dashboard from "./components/admin/Dashboard"
import NotFound from "./components/layout/NotFound"
import Orders from "./components/admin/Orders"
import Profile from "./components/profile/Profile"


import "./styles/app.scss"
import "./styles/header.scss"
import "./styles/home.scss"
import "./styles/founder.scss"
import "./styles/menu.scss"
import "./styles/footer.scss"
import "./styles/contact.scss"
import "./styles/about.scss"
import "./styles/cart.scss"
import "./styles/shipping.scss"
import "./styles/confirmorder.scss"
import "./styles/PaymentSucess.scss"
import "./styles/login.scss"
import "./styles/profile.scss"
import "./styles/table.scss"
import "./styles/orderdetails.scss"
import "./styles/dashboard.scss"



function App() {
  return (
    <Router>
    <Header isAuthentaticted={true}/>
      <Routes>
        <Route path="/" element={<Home/>}/>
        <Route path="/contact" element={<Contact/>}/>
        <Route path="/about" element={<About/>}/>
        <Route path="/cart" element={<Cart/>}/>
        <Route path="/shipping" element={<Shipping/>}/>
        <Route path="/confirmorder" element={<ConfirmOrder/>}/>
        <Route path="/paymentsucess" element={<PaymentSucess/>}/>
        <Route path="/login" element={<Login/>}/>
        <Route path="/me" element={<Profile/>}/>
        <Route path="/myorders" element={<MyOrders/>}/>
        <Route path="/order/:id" element={<OrderDetails/>}/>
        <Route path="/admin/dashboard" element={<Dashboard/>}/>
        <Route path="/admin/orders" element={<Orders/>}/>
    
        <Route path="*" element={<NotFound/>}/>
      </Routes>
    <Footer/>
    </Router>
    
  )
 
}

export default App;
